module.exports = "/img/bmw.4ccfe1f3.png";